import { api } from '../../_generated/api/assets-api.generated';

export const tagsApi = api.enhanceEndpoints({
  addTagTypes: ['Tag'],
  endpoints: {
    ReadAllTags: {
      providesTags: (result) => {
        if (!result?.readAllTags?.items) {
          return [{ type: 'Tag' as const, id: 'LIST' }];
        }

        const tags = result?.readAllTags.items;

        return [
          ...tags.map(({ name }) => ({
            type: 'Tag' as const,
            id: name,
          })),
          { type: 'Tag' as const, id: 'LIST' },
        ];
      },
      forceRefetch: ({ currentArg, previousArg }) => {
        // Refetch if filter changes or if requesting next page
        return currentArg !== previousArg;
      },
    },
    CreateTag: {
      async onQueryStarted(newTag, { dispatch, queryFulfilled, getState }) {
        const currentData = tagsApi.endpoints.ReadAllTags.select()(getState());

        if (currentData?.data?.readAllTags?.items) {
          const patchResult = dispatch(
            tagsApi.util.updateQueryData('ReadAllTags', undefined, (draft) => {
              draft.readAllTags.items.push({
                ...newTag.tag,
              });
            }),
          );

          try {
            await queryFulfilled;
          } catch {
            patchResult?.undo();
          }
        }
      },
    },
    DefineAssetTags: {
      invalidatesTags: (_, __, args) => [
        {
          type: 'Tag' as const,
          id: `${args.assetType}:${args.assetId}`,
        },
      ],
    },
    ReadLinkedTagsForAsset: {
      providesTags: (_, __, args) => [
        {
          type: 'Tag' as const,
          id: `${args.assetType}:${args.assetId}`,
        },
      ],
    },
    ReadAllFullTags: {
      providesTags: (result) => {
        if (!result?.readAllTags?.items) {
          return [{ type: 'Tag' as const, id: 'LIST' }];
        }

        const tags = result?.readAllTags.items;

        return [
          ...tags.map(({ name }) => ({
            type: 'Tag' as const,
            id: name,
          })),
          { type: 'Tag' as const, id: 'LIST' },
        ];
      },
    },
    DeleteTag: {
      invalidatesTags: (_, __, args) => [
        { type: 'Tag' as const, id: args.name },
        { type: 'Tag' as const, id: 'LIST' },
      ],
    },
  },
});

export const {
  useCreateTagMutation,
  useReadAllTagsQuery,
  useReadAllFullTagsQuery,
  useDefineAssetTagsMutation,
  useReadLinkedTagsForAssetQuery,
  useLazyReadLinkedTagsForAssetQuery,
  useDeleteTagMutation,
} = tagsApi;
